import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/index.js'
import Element from 'element-ui'
import util from './utils/util.js'
import './assets/css/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

import { post, get, patch, put } from './utils/api'
import { Swipe, SwipeItem, Lazyload } from 'vant'
Vue.use(Lazyload)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Element, {
  size: 'small'
}) // 定义全局变量

Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$util = util
// 顶部导航栏目
Vue.prototype.$nav1 = [{
  id: 0,
  url: '/',
  name: '首页'
},
{
  id: 1,
  url: 'https://www.gxgzlm.com/',
  name: '考试报名专栏',
  flag: true
}, {
  id: 2,
  url: '/xxjj/xxgk?ids=0',
  name: '广信概况'
}, {
  id: 3,
  url: '/zsxx/dtxx?ids=0',
  name: '招生简章'
},
{
  id: 4,
  url: '/zszy?ids=0',
  name: '院系专业'
},
{
  id: 5,
  url: '/zsjh?ids=0',
  name: '招生计划'
},
{
  id: 6,
  url: '/zsxx/dzzl?ids=0',
  name: '校企合作'
},
{
  id: 7,
  url: '/lxwm?ids=0',
  name: '联系我们'
}]

// 侧边导航栏目
Vue.prototype.$nav2 = [{
  id: 0,
  url: '/xxjj/xxgk',
  name: '广信概况'
}]
Vue.prototype.$nav3 = [{
  id: 0,
  url: '/search',
  name: '搜索结果'
}]
Vue.prototype.$nav4 = [{
  id: 0,
  url: '/article',
  name: '文章详情'
}]
Vue.prototype.$nav5 = [{
  id: 0,
  url: '/lxwm',
  name: '联系我们'
}]
Vue.prototype.$nav6 = [{
  id: 0,
  url: '/zszy',
  name: '院系专业'
}]
Vue.prototype.$nav7 = [{
  id: 0,
  url: '/zsjx',
  name: '招生计划'
}]
Vue.prototype.$nav8 = [{
  id: 0,
  url: '/lnfs',
  name: '历年分数'
}]
Vue.prototype.$nav9 = [{
  id: 0,
  url: '/zsxx/dtxx',
  name: '招生简章'
}]
Vue.prototype.$nav10 = [{
  id: 0,
  url: '/zsxx/dzzl',
  name: '校企合作'
}]
Vue.prototype.$nav11 = [{
  id: 0,
  url: '/yxxw',
  name: '招生简章'
}]
Vue.prototype.$nav12 = [{
  id: 0,
  url: '/xydt',
  name: '校园动态'
}]
Vue.prototype.$nav13 = [{
  id: 0,
  url: '/jzzc',
  name: '奖助政策'
}]
Vue.prototype.$nav14 = [{
  id: 0,
  url: '/zsxx/zsdt',
  name: '招生动态'
}]
Vue.prototype.$nav15 = [{
  id: 0,
  url: '/work/jydt',
  name: '就业动态'
}]
Vue.prototype.$nav16 = [{
  id: 0,
  url: '/work/jycy',
  name: '就业创业'
}]
Vue.prototype.$nav17 = [{
  id: 0,
  url: '/zsxx/single',
  name: '单招'
}]
Vue.prototype.$nav18 = [{
  id: 0,
  url: '/zsxx/counterpart',
  name: '对口'
}]
Vue.prototype.$nav19 = [{
  id: 0,
  url: '/zsxx/series',
  name: '统考'
}]
Vue.prototype.$nav20 = [{
  id: 0,
  url: '/campus',
  name: '多彩校园'
}, {
  id: 1,
  url: '/xyfg',
  name: '校园风光'
}]
Vue.prototype.$nav21 = [{
  id: 0,
  url: '/xxjj/szll',
  name: '名师风采'
}]
Vue.prototype.$nav22 = [{
  id: 0,
  url: '/xxjj/student',
  name: '学子风采'
}]
Vue.prototype.$nav23 = []
// Vue.prototype.$nav4 = [{
//   id: 0,
//   url: '/lqcx',
//   name: '录取查询',
// }]
// Vue.prototype.$nav2 = [{
//   id: 0,
//   url: '/xyfg',
//   name: '校园风光',
// }]

// Vue.prototype.$nav4 = [{
//   id: 0,
//   url: '/zsxx/dtxx',
//   name: '招生信息'
// }]
// Vue.prototype.$nav5 = [{
//   id: 0,
//   url: '/cjwt',
//   name: '热点问答',
// }]

// Vue.prototype.$nav8 = [{
//   id: 0,
//   url: '/zsxx/dzzl',
//   name: '招生动态',
// }]
// Vue.prototype.$nav9 = [{
//   id: 0,
//   url: '/yxxw',
//   name: '院系新闻',
// }]

Vue.config.productionTip = false

// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
